import { render, staticRenderFns } from "./LayoutInsightsNav.vue?vue&type=template&id=764f42cf&scoped=true&"
import script from "./LayoutInsightsNav.vue?vue&type=script&lang=js&"
export * from "./LayoutInsightsNav.vue?vue&type=script&lang=js&"
import style0 from "./LayoutInsightsNav.vue?vue&type=style&index=0&id=764f42cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764f42cf",
  null
  
)

export default component.exports